import { render, staticRenderFns } from "./PatientChartReview.vue?vue&type=template&id=dbbbbdfa&"
import script from "./PatientChartReview.vue?vue&type=script&lang=js&"
export * from "./PatientChartReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports